module.exports = __webpack_public_path__ + "img/pr-1.3809cd7f.png";